import actionTypes from "#/redux/actions/actionTypes"
import { Action, combineReducers } from "redux"
import { RootState } from "./index"
import { Subsidies } from "#/lib/carrot-api/types/Subsidy"
import TestUserActionTypes from "#/redux/actions/testUserActionTypes"

const { FETCH_SUBSIDIES_SUCCESS } = actionTypes

type SubsidiesResponse = Subsidies | null

type FetchSubsidiesSuccessAction = Action<typeof FETCH_SUBSIDIES_SUCCESS> & {
  response?: SubsidiesResponse
}

type ToggleSubsidiesOverrideAction = Action<typeof TestUserActionTypes.TOGGLE_SUBSIDIES_OVERRIDE> & {
  response?: SubsidiesResponse
}

const subsidies = combineReducers({
  subsidies: (state: SubsidiesResponse = null, action: FetchSubsidiesSuccessAction | ToggleSubsidiesOverrideAction) => {
    switch (action.type) {
      case FETCH_SUBSIDIES_SUCCESS:
      case TestUserActionTypes.TOGGLE_SUBSIDIES_OVERRIDE:
        return action.response
      default:
        return state
    }
  }
})

export const getSubsidies = (state: RootState) => state.subsidies.subsidies

export default subsidies
